import { MapPin } from 'lucide-react';
import type { CampusLocation, WorkOrderPriority, WorkOrderStatus } from '../lib/types';
import { CAMPUS_LOCATION_LABEL, WORK_ORDER_PRIORITY_LABEL, WORK_ORDER_STATUS_LABEL } from '../lib/work-orders';
import { Badge } from './ui';

type Tone = Parameters<typeof Badge>[0]['tone'];

const STATUS_TONE: Record<WorkOrderStatus, Tone> = {
  OPEN: 'blue',
  IN_PROGRESS: 'violet',
  WAITING: 'amber',
  RESOLVED: 'green',
  CLOSED: 'gray',
};

export function WorkOrderStatusBadge({ status }: { status: WorkOrderStatus }) {
  return <Badge tone={STATUS_TONE[status]}>{WORK_ORDER_STATUS_LABEL[status]}</Badge>;
}

const PRIORITY_TONE: Record<WorkOrderPriority, Tone> = { LOW: 'gray', NORMAL: 'gray', HIGH: 'amber', URGENT: 'red' };

export function PriorityBadge({ priority }: { priority: WorkOrderPriority }) {
  return <Badge tone={PRIORITY_TONE[priority]}>{WORK_ORDER_PRIORITY_LABEL[priority]}</Badge>;
}

const CAMPUS_TONE: Record<CampusLocation, Tone> = { ON_CAMPUS: 'green', OFF_CAMPUS: 'amber', UNKNOWN: 'gray' };

export function CampusBadge({ location }: { location: CampusLocation | null | undefined }) {
  if (!location) return null;
  return (
    <Badge tone={CAMPUS_TONE[location]}>
      <MapPin className="size-3" />
      {CAMPUS_LOCATION_LABEL[location]}
    </Badge>
  );
}
